import { render } from "./EmbrioImport.vue?vue&type=template&id=eb653d96"
import script from "./EmbrioImport.vue?vue&type=script&lang=js"
export * from "./EmbrioImport.vue?vue&type=script&lang=js"

import "./EmbrioImport.vue?vue&type=style&index=0&id=eb653d96&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__